import * as React from "react";
import { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";

//Components
import SidebarContainer from "../Sidebar/SidebarContainer";
import Footer from "../Footer/Footer";
import HeaderContainer from "../Header/HeaderContainer";

import "./MainLayout.scss";

class MainLayout extends Component {
  render() {
    return (
      <Container fluid className="mainLayout">
        <Row>
          <Col md={1}>
            <SidebarContainer />
          </Col>
          <Col md={11} className="mainComponent">
            <HeaderContainer />
            <div className="subComponent">{this.props.children}</div>
            <Footer />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MainLayout;
